import { createComponent } from '@lit/react';
import React from 'react';
import { SDSNotification } from '../sds-notification/sds-notification';
import { SheriffEventName } from './types';

export const SDSNotificationWrapper = createComponent({
	tagName: 'sds-notification',
	elementClass: SDSNotification,
	react: React,
	events: {
		onRemove: 'sds-remove' as SheriffEventName,
	},
});
